module.exports = __webpack_public_path__ + "fonts/GT-America-Standard-Regular.c0286304.woff";